import React, {FC, ReactElement, useEffect, useRef, useState} from 'react';
import './Image.scss';
import styled from 'styled-components';

type imgProps = {
    src: string,
    updatedSrc:string|null,
    alt: string,
    isShadow: boolean,
    shape: string,
    round: string,
    width: string,
    verticalAlignment: string,
    horizontalAlignment: string,
    isLinkActive: boolean,
    linkUrl: string,
    linkAnalyticEvent: string,
    isOpenLinkInNewTab: boolean,
    cropData:any,
    isAnchorActive:boolean,
    anchorName:string,
    anchorTrigger: string,
    selectedLinkType: string|null
}

type imageWrapperProps = {
    verticalAlignment: string,
    horizontalAlignment: string,
}

type imageLayoutProps = {
    width: string,
    round: string,
    shape: string,
    isShadow: boolean,
    elementWidth:number
}

type imageElementProps = {
    round: string,
}

const ImageWrapper = styled.div<imageWrapperProps>`
&.imageWrapper {
  align-items: ${props => props.verticalAlignment || 'inherit'};
  justify-content: ${props => props.horizontalAlignment || 'inherit'};
  @media (max-width:768px) {
    align-items: center;
    justify-content: center;
  }
}
`;

const ImageLayout = styled.div<imageLayoutProps>`
&.imageLayout {
 ${props => props.shape === 'circle' &&`
      border-radius: 100% !important;
      padding-top: ${props.width + '%' || '100%'};
      img {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
   `};
     ${props => (props.shape === 'square') &&`
      padding-top: ${props.width + '%' || '100%'};
      img {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
   `};
    ${props => (props.shape === '16-9') &&`
       ${(!props.elementWidth || props.elementWidth === 0) &&`
        padding-top: 56.25%;
      `};
       ${(props.elementWidth > 0) &&`
        padding-top: ${Math.round(56.25*(Number(props.elementWidth)/100)*(Number(props.width)/100)) + 'px'};
      `};
      img {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
   `};
  width: ${props => props.width + '%' || '100%'};
  max-width:100%;
  border-radius: ${props => props.round ? props.round : '0'};
  box-shadow: ${props => props.isShadow ? 'rgba(0, 0, 0, 0.15) 0px 4px 8px' : 'none'};
}
`;

const ImageLayoutLink = styled.a<imageLayoutProps>`
&.imageLayout {
  ${props => props.shape === 'circle' &&`
      border-radius: 100% !important;
      padding-top: ${props.width + '%' || '100%'};
      img {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
   `};
     ${props => (props.shape === 'square') &&`
      padding-top: ${props.width + '%' || '100%'};
      img {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
   `};
   ${props => (props.shape === "16-9") &&`
      padding-top: ${Math.round(56.25*(Number(props.elementWidth)/100)*(Number(props.width)/100)) + 'px'};
      img {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
   `};
  width: ${props => props.width + '%' || '100%'};
  max-width:100%;
  border-radius: ${props => props.round ? props.round : '0'};
  box-shadow: ${props => props.isShadow ? 'rgba(0, 0, 0, 0.15) 0px 4px 8px' : 'none'};
}
`;

const ImageElement = styled.img<imageElementProps>`
  border-radius: ${props => props.round ? props.round : '0'};
  ${props => (props.round === '100%' || props.round === '100px') &&`
  border-radius: 100%;
  `};
`;


const Image: FC<imgProps> = ({...props}): ReactElement => {

    const imgSrc = props.updatedSrc || props.src || environmentLink + '/assets/images/imagePlaceholder.jpg';

    const elementRef = useRef<any>(null);
    const [elementDomWidth, setElementDomWidth] = useState(elementRef?.current?.clientWidth || 100);

    useEffect(() => {
        setElementDomWidth(elementRef?.current?.clientWidth);
    }, [])

    function getImageElement() {
        return <ImageElement src={imgSrc} alt={props.alt} round={props.round}/>;
    }

    if((props.isLinkActive && !props.selectedLinkType) || props.selectedLinkType === 'hyperlink') {
        return (
            <ImageWrapper className={'imageWrapper'} verticalAlignment={props.verticalAlignment} horizontalAlignment={props.horizontalAlignment}
                          data-analytics-click-event={props.linkAnalyticEvent} ref={elementRef}>
                <ImageLayoutLink className={'imageLayout'} href={props.linkUrl} target={props.isOpenLinkInNewTab ? '_blank' : '_self'} round={props.round}
                                 width={props.width} isShadow={props.isShadow} shape={props.shape} data-src={imgSrc}
                                 elementWidth={elementDomWidth}>
                    {getImageElement()}
                </ImageLayoutLink>
            </ImageWrapper>
        );
    }
    else {
        return (
            <ImageWrapper className={'imageWrapper'} verticalAlignment={props.verticalAlignment} horizontalAlignment={props.horizontalAlignment} ref={elementRef}>
                <ImageLayout className={'imageLayout'} round={props.round} width={props.width} isShadow={props.isShadow} shape={props.shape} data-src={imgSrc} elementWidth={elementDomWidth}>
                    {getImageElement()}
                </ImageLayout>
            </ImageWrapper>
        );
    }

};


//element settings
let settings:any;
let SettingsData;
const environmentLink:any = window.getEnvironmentLink();
try {
    SettingsData = require('../../../settings-data').default;
    // do stuff
} catch (ex) {
    SettingsData = null;
}
if(SettingsData) {
    const settingsClass = new SettingsData();
    const allSettings = settingsClass.getAllSettings();
    settings = [
        [//group
            {
                settingName: 'HorizontalAlignment',
            },
        ],
        [//group
            {
                settingName: 'AddImage',
                title: 'Image',
                isMainSettings: true
            },
        ],
        [//group
            {
                settingName: 'Size',
                controls: [
                    {
                        controlName: 'Slider',
                        title: 'Size',
                        property: 'width',
                        defaultValue: 70,
                        suffix: '%',
                        min: 10
                    },
                ],
            },
            {
                settingName: 'Cropper',
            },
            {
                settingName: 'Shape',
            },
            {
                settingName: 'BorderRadius',
            },
            {
                settingName: 'Shadow',
            },
            {
                settingName: 'Link',
            },
            {
                settingName: 'Anchor',
            },
        ]
    ];
}

//element options
const options = [
    {
        name:'change',
        title: 'Change',
        icon: environmentLink + '/assets/images/change-image.svg',
        action: 'openMediaLibrary',
        settingTitle: 'Image'
    },
    {
        name:'size',
        title: 'Size',
        icon: environmentLink + '/assets/images/Options/size.svg',
        action: 'setActiveWidth',
        settingTitle: 'Size'
    }
]

export default {
    Image,
    settings,
    options,
    label: 'Image'
};


